import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 px-4 text-center">
      <div className="text-7xl font-bold text-slate-300">404</div>
      <p className="max-w-md text-slate-600">
        {t('brand.name')}
      </p>
      <Button asChild>
        <Link to="/">{t('common.back')}</Link>
      </Button>
    </div>
  );
}
